<div class="page-header">
    <div class="page-header-text">Review payment details</div>
</div>

<div class="page-body">
    <bolt-notification class="tM-20px bM-20px" *ngIf="showErrorMessage">We are unable to process your payment at this time. Please try again in a few minutes or contact Customer Service for assistance.</bolt-notification>
    <form [formGroup]="myform" id="myform" novalidate>
        <bolt-notification class="tM-20px bM-20px" *ngIf="submitted&& !myform.valid">Please correct all errors below.</bolt-notification>
        <div class="bc-gray-25 P-20px body-text" *ngIf="payment">
            <!-- <div class="dFlex bM-12px">
                <div class="width-50 body-bold">Confirmation number:</div>
                <div class="width-50">05588645688888</div>
            </div> -->
            <div class="dFlex bM-12px">
                <div class="width-50 body-bold">Policy:</div>
                <div class="width-50 text-left">{{userInfo?.productType}}&nbsp;<span class="policy-id">{{userInfo?.policyNumber}}</span></div>
            </div>
            <div class="dFlex bM-12px">
                <div class="width-50 body-bold">Payment Amount:</div>
                <div class="width-50">${{paymentAmount.toFixed(2)}}</div>
            </div>
            <div class="dFlex bM-12px text-left">
                <div class="width-50 body-bold">Payment Method:</div>
                <div class="width-50 text-left" *ngIf="payment.bankDetails">{{payment.paymentMethod}} ({{payment.bankDetails.bankAccountNumber | hideChars}})</div>
                <div class="width-50" *ngIf="payment.creditCard">{{payment.creditCard.cardType}} {{payment.paymentMethod}} (**** {{payment.creditCard.cardNumberLastFour}})</div>
            </div>
            <div class="dFlex bM-12px text-left">
                <div class="width-50 body-bold">Account holder's name:</div>
                <div class="width-50 text-left" *ngIf="payment.bankDetails && payment.bankDetails.nameOnAccount">{{payment.bankDetails.nameOnAccount}}</div>
                <div class="width-50" *ngIf="payment.creditCard && payment.creditCard.nameOnCard">{{payment.creditCard.nameOnCard}}</div>
                <div class="width-50" *ngIf="payment.bankDetails && !payment.bankDetails.nameOnAccount">{{payment.bankDetails.firstName}} {{payment.bankDetails.lastName}}</div>
                <div class="width-50" *ngIf="payment.creditCard && !payment.creditCard.nameOnCard">{{payment.creditCard.firstName}} {{payment.creditCard.lastName}}</div>
            </div>
            <div class="dFlex bM-12px text-left" *ngIf="payment.bankDetails && payment.bankDetails.address">
                <div class="width-50 body-bold">Account holder's address:</div>
                <div class="width-50">{{payment.bankDetails.address}}, {{payment.bankDetails.state}} {{payment.bankDetails.zipCode}}</div>
            </div>
            <div class="dFlex text-left">
                <div class="width-50 body-bold">Payment date:</div>
                <div class="width-50">{{currentDate|date:'MM/dd/yyyy'}}</div>
            </div>
        </div>
        <div>
            <div class="body-heading">
                Please read and confirm:
            </div>
            <div>
                <div class="text-box">
                    <div class="text-box-content body-text">
                        <div *ngIf="payment && payment.paymentMethod=='Bank Account'">
                            <div class="body-bold">Bank Recurring Automated Clearing House (ACH) authorization</div>
                            <div>
                                By selecting the button below, you authorize Nationwide Life Insurance Company
                                and/or Nationwide Life and Annuity Insurance Company to electronically debit (withdraw)
                                and/or correct by electronic credit (deposit) your life insurance premium payments from
                                the
                                bank
                                account provided and as allowed by U.S. law.
                            </div>
                        </div>
                        <div *ngIf="payment && payment.paymentMethod=='Credit Card'">
                            <div class="body-bold">Card Recurring Automated Clearing House (ACH) authorization</div>
                            <div>
                                By selecting the button below, you authorize Nationwide Life Insurance Company
                                and/or Nationwide Life and Annuity Insurance Company to electronically debit (withdraw)
                                and/or correct by electronic credit (deposit) your life insurance premium payments from
                                the
                                bank
                                account provided and as allowed by U.S. law.
                            </div>
                        </div>
                    </div>
                </div>
                <bolt-checkbox class="tM-20px" formControlName="generalTerms" required ngDefaultControl
                [error]="myform.get('generalTerms')?.touched && !myform.get('generalTerms')?.valid?'Please confirm you have read the text above by checking the box in order to submit this request.':null">
                I confirm that I have read and accept the terms as described above.</bolt-checkbox>
            </div>
        </div>
        <div>
            <div class="body-heading">
                1-time adjustment payment
            </div>
            <div class="body-text">
                Sometimes during the underwriting process, the premium needed to place your <br />
                policy in force changes. If the amount needed increases, we will require an <br />
                additional payment from you. By authorizing a 1-time adjustment payment now, <br />
                you give Nationwide permission to draft this additional amount using the same <br />
                method you provided for your initial premium payment today. If you do&nbsp;<span
                    class="body-bold-note">not</span> <br />
                authorize the 1-time adjustment payment now, we will email you a link to collect <br />
                the additional premium. This could delay the issue of your life insurance policy. <br />
                Your financial professional will contact you if your premium increases or <br />
                decreases during underwriting. Please contact them with any questions.
            </div>
        </div>

        <div>
            <div class="body-text body-bold tM-20px">1-time adjustment of initial premium payment</div>
            <bolt-checkbox formControlName="paymentTerms" required ngDefaultControl class="bolt-text"
            [error]="myform.get('paymentTerms')?.touched && !myform.get('paymentTerms')?.valid?'Please confirm you have read the text above by checking the box in order to submit this request.':null">
                By checking this box, I authorize a 1-time
                <span *ngIf="payment && payment.paymentMethod=='Bank Account'">ACH debit</span>
                <span *ngIf="payment && payment.paymentMethod=='Credit Card'">charge to my credit card on file</span>&nbsp;for
                <br />
                the difference between the initial premium payment amount and any <br />
                increased amount that is determined during underwriting. If required, I <br />
                understand that this 1-time charge will be made to my credit card on the <br />
                date the policy is activated (placed in force).<br /><br />
                <div class="body-checkbox-note">
                <span class="body-bold-note">NOTE:</span>&nbsp;
                This 1-time adjustment payment will not occur unless there is an <br />
                increase in the premium amount during underwriting. If the premium amount <br />
                decreases during underwriting, Nationwide will refund any excess premium <br />
                via 1-time<span *ngIf="payment && payment.paymentMethod=='Bank Account'">&nbsp;ACH</span>&nbsp;credit unless
                instructed otherwise.
                </div>
            </bolt-checkbox>
        </div>
    </form>
</div>


<div class="page-footer">
    <bolt-button-bar class="footer-button-bar">
        <bolt-button slot="cancel" (click)="onCancel()">Cancel</bolt-button>
        <bolt-button slot="back" (click)="onBack()">Back</bolt-button>
        <bolt-button slot="forward" type="primary" (click)="onSubmit()">Submit
            payment</bolt-button>
    </bolt-button-bar>
</div>